import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Card, Space, Typography } from 'antd';
import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import AppLayout from './AppLayout';

const { Title } = Typography;

interface PageLayoutProps {
  children: ReactNode;
  title: string;
  backTo?: string;
  maxWidth?: number;
}

const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  title,
  backTo = '/',
  maxWidth = 800
}) => {
  const navigate = useNavigate();

  return (
    <AppLayout>
      <Space direction="vertical" size="large" style={{ width: '100%', maxWidth }}>
        <Button
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(backTo)}
          type="text"
        >
          Back to Home
        </Button>

        <Card>
          <Title level={2} style={{ marginTop: 0 }}>
            {title}
          </Title>

          {children}
        </Card>
      </Space>
    </AppLayout>
  );
};

export default PageLayout;
